class TooltipModal {
    constructor(element, options) {
        this.element = element;
        this.options = options;

        this.modal = document.querySelector('.modal');
        this.modalContent = document.querySelector('.modal__content');
        this.modalOverlay = document.querySelector('.modal__overlay');

        this.content = JSON.parse(this.options.tooltipContent);
        this.contentHeading = this.content.heading;
        this.contentBody = this.content.body;
        this.contentButtonLink = this.content.buttonLink;
        this.contentButtonText = this.content.buttonText;

        this.template = `
            <div class="page page--modal">
                <header class="page__header">
                    <h2 class="page__heading">${this.contentHeading}</h2>
                </header>
                <div class="page__content">
                    <p>${this.contentBody}</p>
                </div>
                <div class="page__footer">
                    <a target="_blank" href="${this.contentButtonLink}">${this.contentButtonText}</a>
                </div>
            </div>`;

        this._init();
    }

    _init() {
        this._addTooltipEventListeners();
    }

    _addTooltipEventListeners() {
        this.element.addEventListener('click', this._handleTooltipContent.bind(this));
    }

    _handleTooltipContent() {
        this._initModal();
    }

    _initModal() {
        this._openModal();
        this._addModalContent();
        this._hideModalLoader();
        this._addModalEventListeners();
    }

    _addModalEventListeners() {
        this.modalOverlay.addEventListener('click', this._closeModal.bind(this));
    }

    _openModal() {
        document.body.dispatchEvent(new CustomEvent('modal.open'));
        this.modal.classList.add('modal--small');
    }

    _addModalContent() {
        this.modalContent.innerHTML = this.template;
    }

    _hideModalLoader() {
        document.body.dispatchEvent(new CustomEvent('modal.hideLoader'));
    }

    _closeModal() {
        document.body.dispatchEvent(new CustomEvent('modal.close'));
    }
}
